import { useState } from "react";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import East from '@mui/icons-material/East';


export const TestimonialCarouselNew = () => {
   const [currentImageIndex, setCurrentImageIndex] = useState(0)

   const next = () => {
      if (currentImageIndex === testimonials.length - 1) {
         setCurrentImageIndex(0)
      } else {
         setCurrentImageIndex(currentImageIndex + 1)
      }
   };

   const prev = () => {
      if (currentImageIndex === 0) {
         setCurrentImageIndex(testimonials.length - 1)
      } else {
         setCurrentImageIndex(currentImageIndex - 1)
      }
   }

   const testimonials = [
      "./assets/media/Variant4.png",
      "./assets/media/Variant5.png",
      "./assets/media/Testimonial Chenoa Farnsworth.png",
      "./assets/media/Testimonial Sonali Vijayavargiya.png",
      "./assets/media/Testimonial Igal Ladabaum.png",
      "./assets/media/Testimonial Isaac Bright.png",
      "./assets/media/Component 22.png",
      "./assets/media/Component 23.png",
      "./assets/media/Component 24.png",
      "./assets/media/Component 27.png",
   ];
   return (
      <div style={{ background: "linear-gradient(90deg, #092CA8, #00C2FF" }}>
         <div
            style={{ maxWidth: "1200px", margin: "auto", background: "transparent", display: 'flex', alignItems: 'center' }}
         >
            <East fontSize="large" sx={{ color: "white", transform: "scaleX(-1)" }} onClick={prev} />
            <Carousel autoPlay interval={5000} infiniteLoop={true} showThumbs={false} showStatus={false} selectedItem={currentImageIndex} showArrows={false}>
               {testimonials.map((testimonial, i) => {
                  return (
                     <div style={{ background: "transparent " }}>
                        <img alt='testimonial' src={testimonial} />
                     </div>
                  );
               })}
            </Carousel>
            <East fontSize="large" sx={{ color: "white" }} onClick={next} />
         </div>
      </div>
   );
};
